<!--
 * @Author: cryi.liu
 * @Date: 2020-05-14 13:56:52
 * @LastEditTime: 2020-06-14 10:50:08
 * @Description: 待编辑题库题目列表表格
 -->
<template>
  <i-table :columns="columns" :data="data" />
</template>

<script>
export default {
  name: 'WaitEditQuestionTable',
  props: {
    data: { type: Array, required: true },
  },
  data() {
    return {
      columns: [
        {
          title: '题型',
          key: 'questionType',
          render: (h, params) => h('div', [
            h('span', params.row.questionType),
          ]),
        },
        {
          title: '题目ID',
          key: 'dateSequence',
          align: 'center',
        },
        {
          title: '题目',
          key: 'content',
          align: 'center',
        },
        {
          title: '难易度',
          key: 'level',
          align: 'center',
        },
        {
          title: '创建人',
          key: 'createUser',
          align: 'center',
        },
        {
          title: '创建时间',
          key: 'createDate',
          align: 'center',
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => h('div', [
            h('a', {
              style: {
                marginRight: '5px',
              },
              on: {
                click: this.routeToQuestionDetail(params.row),
              },
            }, '编辑'),
            h('a', {
              on: {
                click: this.deleteQuestionHandler(params.row),
              },
            }, '删除'),
          ]),
        },
      ],
    };
  },
  methods: {
    /**
     * 删除题库题目处理函数
     */
    deleteQuestionHandler({ id }) {
      return () => {
        if (window.confirm('确认删除?')) {
          this.deleteId = id;

          this.requestDeleteQuestionAndRepull();
        }
      };
    },
    /**
     * 请求删除题库题目并重新请求列表
     */
    requestDeleteQuestionAndRepull() {
      this.requestDeleteQuestion()
        .then(() => {
          this.$emit('repull-wait-edit-list');
        })
        .catch(() => {
        });
    },
    /**
     * 请求删除题库题目
     */
    requestDeleteQuestion() {
      return new Promise(async (resolve, reject) => {
        const params = {
          libraryIds: this.deleteId,
        };

        const result = await this.$http.examcenter.libraryDeleteQuestion(params);

        if (result.success) {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 跳转到题目详情页
     */
    routeToQuestionDetail({ id }) {
      return () => {
        if (process.env.NODE_ENV === 'development') {
          window.open(`#/question/detail/${id}`, '_blank');
        } else {
          window.open(`/examcentersite/#/question/detail/${id}`, '_blank');
        }
      };
    },
  },
};
</script>

<style lang="less" scoped>
</style>
